<template>
    <div v-redirect-if-no-permission:CAPTAIN_CANCELLATION_REASONS>
        <v-checkbox label="Show Deleted" v-model="deleted"/>
        <data-table :url="api.ACTIONS.CAPTAIN_CANCELLATION_REASONS"
                    :fields-hidden-add="['id','created_at','updated_at','deleted_at']"
                    :fields-extra-add="['text']"
                    :enable-edit="false"
                    force-reload
                    :initial-url-search-params="params"
                    :formatter="formatter"
                    :row-call-back="rowCallBack"
                    disable-search
                    title="Captain Cancellation Reasons"
        />
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        data() {
            return {
                deleted: false,
                rowCallBack(item) {
                    if (!!item.deleted_at) return ["deleted-item"];
                    return [];
                },
            }
        },
        computed: {
            params() {
                const params = new URLSearchParams();
                if (this.deleted)
                    params.append("all", "1");

                return params;
            },

            formatter() {
                return {
                    deleted_at(val) {
                        if (!val)
                            return "N\\A";
                        return val;
                    }
                }
            }
        },
        name: "captain_cancellation_reasons",
        components: {DataTable},
        title: "Captain Cancellation Reasons"
    }
</script>

<style>
    .deleted-item {
        background-color: lightcoral;
    }
</style>
